const Popup = ({ heading, handleClose, children }) => {
  return (
    <div id="attachment_popup">
      <div className="popup-backdrop">
        <div className="popup">
          {/* Popup Header */}
          <div className="popup-header">
            <h4 className="popup-title">{heading}</h4>
            <button className="view-close" onClick={handleClose}>
              <svg
                width="28"
                height="28"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 0C12.8355 0 9.74207 0.938383 7.11088 2.69649C4.4797 4.45459 2.42894 6.95345 1.21793 9.87706C0.00693274 12.8007 -0.309921 16.0177 0.307443 19.1214C0.924806 22.2251 2.44866 25.0761 4.6863 27.3137C6.92394 29.5513 9.77487 31.0752 12.8786 31.6926C15.9823 32.3099 19.1993 31.9931 22.1229 30.7821C25.0466 29.5711 27.5454 27.5203 29.3035 24.8891C31.0616 22.2579 32 19.1645 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0ZM20.055 21.8L16 17.745L11.945 21.8C11.8318 21.9186 11.6961 22.0135 11.5457 22.0789C11.3954 22.1443 11.2335 22.179 11.0695 22.1809C10.9056 22.1828 10.7429 22.152 10.591 22.0901C10.4392 22.0283 10.3012 21.9367 10.1853 21.8207C10.0693 21.7048 9.97775 21.5668 9.9159 21.415C9.85404 21.2631 9.82317 21.1005 9.8251 20.9365C9.82704 20.7725 9.86173 20.6106 9.92714 20.4603C9.99255 20.3099 10.0874 20.1742 10.206 20.061L14.261 16.006L10.206 11.951C9.9843 11.7186 9.8623 11.4087 9.86608 11.0875C9.86986 10.7663 9.99913 10.4594 10.2263 10.2322C10.4534 10.0051 10.7603 9.87586 11.0815 9.87207C11.4027 9.86829 11.7126 9.99029 11.945 10.212L16 14.267L20.055 10.212C20.2874 9.99029 20.5973 9.86829 20.9185 9.87207C21.2397 9.87586 21.5466 10.0051 21.7738 10.2322C22.0009 10.4594 22.1301 10.7663 22.1339 11.0875C22.1377 11.4087 22.0157 11.7186 21.794 11.951L17.739 16.006L21.794 20.061C22.0233 20.2923 22.152 20.6048 22.152 20.9305C22.152 21.2562 22.0233 21.5687 21.794 21.8C21.6802 21.915 21.5447 22.0063 21.3953 22.0685C21.2459 22.1307 21.0857 22.1626 20.9239 22.1623C20.7621 22.162 20.6019 22.1296 20.4528 22.0669C20.3036 22.0042 20.1684 21.9124 20.055 21.797V21.8Z"
                  fill="#456ABB"
                />
              </svg>
            </button>
          </div>

          {/* Popup Body */}
          <div className="popup-body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
